import { Loader } from '@ur-solutions/react-components'
import type { ReactNode } from 'react'

type LoaderElement = ReactNode | undefined

export const unlessLoadingDots = (loading: boolean, unknownText: string) => {
  return (element: LoaderElement) =>
    loading ? (
      <Loader.Dots size={32} />
    ) : (
      element ?? <span className="unknown">{unknownText}</span>
    )
}
